import React, { PureComponent, useEffect, useState } from "react";
import stylesSCS from './scs.css';


const SmoothCardScrollingHorizontal = ({ items = [], width, cardWidth, cardHeight, cardMargin, highQualityAnimation, scrollBarMargin=0, onListScroll }) => {

    function init() {

        const wrap = document.querySelectorAll(".smooth-card-scrolling-horizontal .wrap")[0];
        const boxes = document.querySelectorAll(".smooth-card-scrolling-horizontal .box");

        function getIntersectionRatio(i) {
            const a = [wrap.scrollLeft, wrap.scrollLeft + wrap.clientWidth];
            const b = [boxes[i].offsetLeft, boxes[i].offsetLeft + boxes[i].clientWidth];
            const max = Math.max(a[0], b[0]);
            const min = Math.min(a[1], b[1]);
            return Math.max(0, (min - max) / (b[1] - b[0]));
        }

        function onScroll() {
            for (let i = 0; i < boxes.length; i += 1) {
                const intersection = getIntersectionRatio(i);
                const left = boxes[i].offsetLeft - wrap.scrollLeft < 0;
                boxes[i].firstChild.style.cssText = `
                    transform-origin: ${left ? "right center" : "left center"};
                    position: absolute;
                    transform: scale(${intersection});
                    opacity: ${intersection};
                    width: ${cardWidth}px;
                    height: ${cardHeight}px;
                `;
            }
            if (highQualityAnimation) {
                requestAnimationFrame(onScroll);
            }
        }

        if (highQualityAnimation) {
            // Option with more CPU usage, but also more FPS / smooth
            requestAnimationFrame(() => {
                onScroll();
            });
        }
        else {
            // Option with less CPU usage, but also less FPS / smooth
            onScroll();
            wrap.addEventListener('scroll', onScroll);
        }
    }

    React.useEffect(() => {
        setTimeout(() => init(), 500);
    }, []);

    return <div className="smooth-card-scrolling-horizontal" style={{padding: cardMargin, width}}>
        <div className={'wrap'} style={{ overflowX: 'scroll', overflowY: 'hidden', whiteSpace: 'nowrap', paddingBottom: scrollBarMargin + 5 }} onScroll={onListScroll}>
            {items.map((item, i) => <div key={i} className="box" style={{ width: cardWidth, height: cardHeight, display: 'inline-block', marginRight: cardMargin }}>
                <div className={'box-inner'} style={{ width: cardWidth, height: cardHeight }}>
                    {item}
                </div>
            </div>)}
        </div>
    </div>;
}

export default SmoothCardScrollingHorizontal;